import Request from '@/utils/request'

// 节日活动信息-br
export function holidayActBaseInfoBr() {
  return Request({
    url: '/api/v2/app/activity/home',
    method: 'get',
  })
}

// 节日活动排行-br
export function holidayActRankBr() {
  return Request({
    url: '/api/v2/app/activity/gift/rank',
    method: 'get',
  })
}

// 节日活动签到-br
export function holidayDaySignBr() {
  return Request({
    url: '/api/v2/app/activity/daily/sign',
    method: 'post',
  })
}

// 节日活动签到领取-br
export function holidayDayClaimBr(params) {
  return Request({
    url: '/api/v2/app/activity/daily/claim',
    method: 'post',
    params,
  })
}
